import * as React from 'react';
import classnames from 'classnames';

import { getCampaignManagersPreview } from 'utils/campaign';
import { __t, applyTranslations } from 'utils/language';

import type { TeamMember } from 'types';

applyTranslations(require('./campaign-summary-team.i18n.json'));

type Props = {
  team?: Array<TeamMember>,
  className: string
};

class CampaignSummaryTeam extends React.PureComponent<Props> {
  static defaultProps = {
    className: ''
  };

  render(): React.ReactNode {
    const { className, team } = this.props;

    if (!team || !team.length) {
      return null;
    }

    const clasess = classnames('campaign-summary-team', {
      [className]: Boolean(className)
    });

    return (
      <span className={clasess}>
        <span className="campaign-summary-team__label">
          {__t('campaign_summary_team.label')}
        </span>
        { getCampaignManagersPreview(team) }
      </span>
    );
  }
}

export default CampaignSummaryTeam;
